import { render } from "./DialogCanNotGoToSheetMapByPurchaseLimit.vue?vue&type=template&id=78205287"
import script from "./DialogCanNotGoToSheetMapByPurchaseLimit.vue?vue&type=script&lang=js"
export * from "./DialogCanNotGoToSheetMapByPurchaseLimit.vue?vue&type=script&lang=js"
script.render = render

export default script